import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';
import { ToggleService } from '../common/header/toggle.service';
import { environment } from '../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/dialog.component';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { UserInfoService } from '../services/user.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [MatCardModule, RouterModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit, OnDestroy {

  constructor(private toggleService: ToggleService, private dialog: MatDialog,
    private router: Router, private authService: AuthService, private userInfoService: UserInfoService
  ) {}

  isDarkTheme = false;
  supportEmail = 'daniel@tensortag.com';

  userSubscription?: Subscription;
  private changePasswordDialogOpen = false;

  ngOnInit(): void {
    this.isDarkTheme = this.toggleService.isDark();

    this.toggleService.isToggledTheme$.subscribe((toggled) => {
      this.isDarkTheme = toggled;
    });

    this.shouldChangePassword();
  }

  ngOnDestroy(): void {
    this.userSubscription?.unsubscribe();
  }

  shouldChangePassword() {
    if (this.authService.isLoggedIn()) {
      this.userSubscription = this.userInfoService.userInfo$.pipe(take(1)).subscribe({
        next: response => {
          if (!environment.production) {
            console.log('response in home\n', response);
          }
          if (response?.should_change_password) {
            this.passwordChangeDialog();
          }
        },
        error: error => {
          if (!environment.production) {
            console.log('error in home component:\n ', error);
          }
        }
      });
    }
  }

  passwordChangeDialog() {
    if (this.changePasswordDialogOpen) return;
    this.changePasswordDialogOpen = true;

    const dialogRef = this.dialog.open(DialogComponent, {
      width: '500px',
      disableClose: true,
      data: {
        dialogTitle: 'Change your password',
        content: 'You are using a temporary password. For your security, please set a new password in My Profile.',
        newButton: true,
        newButtonName: 'Go to My Profile',
        createFile: false,
        newBtnColor: 'primary'
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.changePasswordDialogOpen = false;
    });

    dialogRef.componentInstance.buttonClicked.subscribe(() => {
      this.router.navigate(['/main/profile']);
      dialogRef.close();
    });
  }
}
